import React from "react";
import Paper from "@mui/material/Paper";
import CircularProgress from "@mui/material/CircularProgress";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";

import { NavLink } from "react-router-dom";
import { TableHead } from "@mui/material";
import FleetWebApi from "../Api/FleetWebApi";
import alertLabsApi from "../Api/AlertLabsApi";
import { useAuthDataContext } from "../AuthDataProvider";

function DevicesOnLocationWrapper(props) {
  const { user } = useAuthDataContext();
  return <DevicesOnLocation {...props} user={user} />;
}

class DevicesOnLocation extends React.Component {
  _isMounted = false;
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      isLoaded: false,
      devices: null,
    };
  }
  async componentDidMount() {
    this._isMounted = true;
    try {
      const result = await FleetWebApi.getSensorsOnLocation(this.props.locationId);
      // One batched lookup for every device instead of one API call each device
      const hardwareIDs = await alertLabsApi.getHardwareIDsFromSensorIDs(
        result.map((device) => device._id),
        'particle',
        this.props.user.token
      );
      const resolvedDevices = result.map((device) => ({
        ...device,
        _id: hardwareIDs.get(device._id) || device._id,
      }));
      if (this._isMounted) {
        this.setState({
          isLoaded: true,
          devices: resolvedDevices,
        });
      }
    } catch (error) {
      if (this._isMounted) {
        this.setState({
          isLoaded: true,
          error,
        });
      }
    }
  }
  componentWillUnmount() {
    this._isMounted = false;
  }
  render() {
    const { error, isLoaded } = this.state;
    if (error) {
      return <div>Error: {error.message}</div>;
    } else if (!isLoaded) {
      return (
        <div>
          <CircularProgress color="secondary" />
        </div>
      );
    } else {
      return (
        <Paper>
          <Table classes={{ root: "reactivetable" }}>
            <TableHead>
              <TableRow>
                <TableCell>Serial</TableCell>
                <TableCell>Core Id</TableCell>
                <TableCell>Type</TableCell>
                <TableCell>Sub-Type</TableCell>
                <TableCell>Friendly Name</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {this.state.devices.map((device, key) => (
                <TableRow key={key}>
                  <TableCell data-th="Serial">
                    <NavLink to={"/device/" + device._id} className="Nav_link">
                      {device.serialNumber.match(/.{3}/g).join(".")}
                    </NavLink>
                  </TableCell>
                  <TableCell data-th="Core ID">{device._id}</TableCell>
                  <TableCell data-th="Type">{device.type}</TableCell>
                  <TableCell data-th="Type">
                    {device.subtype ? device.subtype : "-"}
                  </TableCell>

                  <TableCell data-th="Friendly Name">{device.name}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>
      );
    }
  }
}
export default DevicesOnLocationWrapper;
